export default {
  KEY_TOKEN: 'abtv_token',
  KEY_INFO: 'abtv_info',
  KEY_LANG: 'abtv_lang',
  KEY_GIFT_CODE: 'tv_gift_code',
  KEY_GIFT_UUID: 'tv_gift_uuid'
}
